
import { UseFormReturn } from "react-hook-form";
import { UpdateCandidateContactInfoSchema } from "../schemas/updateCandidateContactInfoSchema";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Save, X } from "lucide-react";

interface ContactInfoFormProps {
  form: UseFormReturn<UpdateCandidateContactInfoSchema>;
  onSubmit: (values: UpdateCandidateContactInfoSchema) => void;
  onCancel: () => void;
  isUpdatingProfile: boolean;
}

export const ContactInfoForm = ({ form, onSubmit, onCancel, isUpdatingProfile }: ContactInfoFormProps) => {
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input placeholder="john.doe@example.com" {...field} disabled={isUpdatingProfile} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Phone</FormLabel>
              <FormControl>
                <Input placeholder="+1234567890" {...field} disabled={isUpdatingProfile} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="linkedin_url"
          render={({ field }) => (
            <FormItem>
              <FormLabel>LinkedIn Profile URL</FormLabel>
              <FormControl>
                <Input placeholder="https://linkedin.com/in/johndoe" {...field} disabled={isUpdatingProfile} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex items-center gap-2 justify-end">
          <Button type="button" variant="outline" size="sm" onClick={onCancel} disabled={isUpdatingProfile}>
            <X className="h-4 w-4 mr-1" /> Cancel
          </Button>
          <Button type="submit" size="sm" disabled={isUpdatingProfile}>
            <Save className="h-4 w-4 mr-1" /> {isUpdatingProfile ? "Saving..." : "Save"}
          </Button>
        </div>
      </form>
    </Form>
  );
};
